import { apiBase } from "./base";

const apiSsrEditor = {
	client: apiBase.get_client(),
	url: "/editor/ssr/",

	getOrCreateCacheJson({ estmId }) {
		return this.client.get(this.url + estmId + "/cache_json/", apiBase.get_headers());
	},

	create({ body }) {
		return this.client.post(this.url + "create/", body, apiBase.get_headers());
	},

	patchSsrData({ estmId, body }) {
		return this.client.patch(this.url + estmId + "/", body, apiBase.get_headers());
	},

	convertJsonToDb({ estmId, asCopy }) {
		let asCopyStr = "0";
		if (asCopy) asCopyStr = "1";
		return this.client.get(this.url + estmId + "/convert_to_db/" + asCopyStr + "/", apiBase.get_headers());
	},

	undoSsrAction({ estmId, actionId }) {
		return this.client.get(this.url + estmId + "/undo/" + actionId + "/", apiBase.get_headers());
	},

	redoSsrAction({ estmId, actionId }) {
		return this.client.get(this.url + estmId + "/redo/" + actionId + "/", apiBase.get_headers());
	},

	createRow({ estmId, body }) {
		return this.client.post(this.url + estmId + "/row/", body, apiBase.get_headers());
	},

	patchRow({ estmId, rowId, body }) {
		return this.client.patch(this.url + estmId + "/row/" + rowId + "/", body, apiBase.get_headers());
	},

	deleteRow({ estmId, rowId }) {
		return this.client.delete(this.url + estmId + "/row/" + rowId + "/", apiBase.get_headers());
	},

	addEstm({ estmId, rowId, rowType }) {
		return this.client.get(this.url + estmId + "/add_estm/" + rowType + "/" + rowId + "/", apiBase.get_headers());
	},

	addCalcsBook({ estmId, calcsBookId }) {
		return this.client.get(this.url + estmId + "/add_calcs_book/" + calcsBookId + "/", apiBase.get_headers());
	},
};

export default apiSsrEditor;
